// src/components/AboutUsBanner.js
import React from 'react';
import './AboutUsBanner.css'; // We’ll define styles separately

const AboutUsBanner = () => {
  return (
    <div className="about-banner text-white d-flex align-items-center">
      <div className="container text-center">
        <h2 className="display-4 fw-bold mt-5">About Us</h2>
       
      </div>
    </div>
  );
};

export default AboutUsBanner;
